






































































































































































































































import { createSimpleTransition } from "vuetify/lib/components/transitions/createTransition";

import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Confirm from "@/components/Confirm.vue";
import { FieldRules, FormRegister } from '@/types';
import { Competence, Contact, Language, Option, PersonTitle } from '@/proxy/Prequalification.CandidateMgt.FacadeClient';
import * as Validation from "@/lib/validation";

const ErrorContacted = createSimpleTransition("error-contacted");

const referenceData = namespace('referenceData');

@Component({
  components: {
    Confirm,
    ErrorContacted,
  },
})
export default class RegisterFormContacts extends Vue {
  @PropSync('registerForm', { type: Object, required: true })
  registerFormSync!: FormRegister;

  @PropSync('isValid', { type: Boolean, required: true })
  isValidSync!: boolean;

  @Prop({ type: Object, required: true })
  readonly rules!: FieldRules;

  @Prop(Boolean)
  readonly isDownloading: boolean = false;
  
  @referenceData.State(state => state.languages)
  readonly languages!: Language[];

  @referenceData.State(state => state.roles)
  readonly roles!: Option[];

  @referenceData.State(state => state.competences)
  readonly competences!: Competence[];

  @referenceData.State(state => state.titles)
  readonly titles!: PersonTitle[];

  currentContactIndex: number = 0;
  selectedContactIndexToDelete: number | null = null;
  showConfirm: boolean = false;

  @Watch('roles')
  onRolesInitialized(values: Option[]) {
    const { contacts } = this.registerFormSync.candidate;
    if (!contacts?.length || contacts.some(c => c.roles?.length)) {
      return;
    }

    this.registerFormSync.candidate.contacts![0].roles = values.map(r => r.code!);
  }

  created() {
    if (!this.registerFormSync.candidate.contacts?.length) {
      this.registerFormSync.candidate.contacts = [this.getNewContact()];
    }
  }

  get selectedContact(): Contact | null {
    return this.selectedContactIndexToDelete !== null
      ? this.registerFormSync.candidate.contacts
        ? this.registerFormSync.candidate.contacts[this.selectedContactIndexToDelete]
        : null
      : null;
  }

  get selectedContactName(): string {
    if (this.selectedContactIndexToDelete == null || !this.selectedContact) {
      return "";
    }
    
    if (this.selectedContact.firstName && this.selectedContact.lastName) {
      return `${this.selectedContact.firstName} ${this.selectedContact.lastName}`;
    }

    if (this.selectedContact.firstName) {
      return this.selectedContact.firstName;
    }

    if (this.selectedContact.lastName) {
      return this.selectedContact.lastName;
    }

    if (this.selectedContact.email) {
      return this.selectedContact.email;
    }

    return `Contact ${this.selectedContactIndexToDelete + 1}`;
  }

  isContactAdmin(contact: Contact): boolean {
    return (contact.roles?.indexOf("Admin") ?? -1) >= 0;
  }

  getRoleLabel(role: Option): string {
    return role.name + (!!role.hint ? " (" + role.hint + ")" : "");
  }

  canEditRole(role: string, contact: Contact, contactIndex: number): boolean {
    return contactIndex !== 0 && (!this.isContactAdmin(contact) || role === "Admin");
  }

  getNewContact(): Contact {
    var result = new Contact();
    result.competences = [];
    result.roles = [];

    return result;
  }

  onChangeRoles(value: string[], contact: Contact, role: string): void {
    if (role === "Admin" && value.indexOf(role) >= 0) {
      contact.roles = this.roles.map(r => r.code!);
    }

    var selected = this.currentContactIndex;
    this.currentContactIndex = 0;
    this.currentContactIndex = selected;
  }

  onAddContact(e: MouseEvent): void {
    e.preventDefault();
    if (this.registerFormSync.candidate.contacts!.length >= 20) return;

    this.registerFormSync.candidate.contacts = [
      ...this.registerFormSync.candidate.contacts!,
      this.getNewContact()
    ];

    // create error boolean
    this.registerFormSync.errors.contactFor.errors = [
      ...this.registerFormSync.errors.contactFor.errors,
      true
    ];

    this.onContactAdded();

    this.currentContactIndex = this.registerFormSync.candidate.contacts.length - 1;
  }

  onChangeContactFor(
    value: boolean,
    contact: Contact,
    contactIndex: number,
    competence: string
  ): void {
    if (value) contact.competences!.push(competence);
    else contact.competences = contact.competences!.filter(c => c !== competence);

    const oneIsCheckedForContact = Validation.checkAtLeastOne(
      this.registerFormSync.errors.contactFor.checkAtLeastOneOption
    )(contact.competences!);
    this.registerFormSync.errors.contactFor.errors[contactIndex] =
      typeof oneIsCheckedForContact !== "boolean";

    this.onContactChanged();
  }

  onDeleteContact(index: number) {
    this.selectedContactIndexToDelete = index;
    this.displayConfirmContact(true);
  }

  displayConfirmContact(bool: boolean): void {
    this.showConfirm = bool;
  }

  onClickConfirm(): void {
    this.registerFormSync.candidate.contacts?.splice(this.selectedContactIndexToDelete ?? 0, 1);

    // remove error boolean
    this.registerFormSync.errors.contactFor.errors.splice(this.selectedContactIndexToDelete, 1);

    this.onContactRemoved();
    
    this.displayConfirmContact(false);
  }

  @Emit('contactAdded')
  onContactAdded() {}

  @Emit('contactChanged')
  onContactChanged() {}

  @Emit('contactRemoved')
  onContactRemoved() {}

  @Emit('downloadGdprClick')
  onDownloadGdprClick() {}
};
